import Type from "../Type";

const initState = {
    isShow: false,
    isShowForPopup: false,
    className: '',
    routeContent: '',
    routeFrom: '',
}

const PopupanelReducer = (state = initState, { type, route, value }) => {
    if (type === Type.SET_STATE_POPUP_PANEL)
        return {
            ...state,
            [route]: value
        }
    return state;
}

export default PopupanelReducer
